import React, { useState } from 'react';
import { toast } from 'react-toastify';

const ChangePasswordModal = ({ onPasswordChanged }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!currentPassword || !newPassword || !confirmPassword) {
            setError('All fields are required.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('New passwords do not match.');
            return;
        }
        if (newPassword.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }
        if (newPassword === currentPassword) {
            setError('New password cannot be the same as the current password.');
            return;
        }

        setIsSaving(true);
        try {
            const token = localStorage.getItem('kk_token');
            const res = await fetch('/api/admin/change-password/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    old_password: currentPassword,
                    new_password: newPassword,
                    new_password2: confirmPassword
                })
            });

            const data = await res.json();
            if (!res.ok) {
                let errorMessage = 'Failed to change password.';
                
                if (data.detail) {
                    errorMessage = data.detail;
                } else if (data.new_password) {
                    errorMessage = Array.isArray(data.new_password) ? data.new_password.join(' ') : data.new_password;
                } else if (data.non_field_errors) {
                    errorMessage = data.non_field_errors.join(' ');
                } else {
                    errorMessage = Object.values(data).flat().join(' ');
                }
                
                throw new Error(errorMessage);
            }

            toast.success('Password changed successfully.');
            onPasswordChanged();

        } catch (err) {
            setError(err.message);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="dialog-container" style={{ maxWidth: '450px' }}>
                <div className="dialog-header">
                    <h3>Change Your Password</h3>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="dialog-body">
                        <p style={{ marginTop: 0, color: '#666' }}>
                            Your password has expired (5-day policy) or is temporary. Please set a new password.
                        </p>
                        <div className="form-group">
                            <label>Current Password</label>
                            <input
                                type="password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>New Password</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Confirm New Password</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <div className="error-message" style={{ color: 'red', marginTop: '10px', padding: '10px', background: '#ffe6e6', borderRadius: '4px' }}>{error}</div>}
                    </div>
                    <div className="dialog-footer">
                        <button type="submit" className="dialog-btn dialog-btn-primary" disabled={isSaving}>
                            {isSaving ? 'Saving...' : 'Set New Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordModal;